import { useParams } from "react-router-dom";
import { CarCardContent } from "../car-card/CarCardContent";
import LeadboxLayout from "@/admin/components/LeadboxLayout";
import BtnNavigateBack from "@/components/ui/btn_navigate_back";
import { useVehicleCard } from "@/hooks/useVehicleCard";
import { useIsMobile } from "@/hooks/use-mobile";
import { getLanguage } from "@/utils/languageUtils";
import { vehicleCardUILabels, commonButtonLabels } from "@/i18n";

import { useShowNavigateBack } from "@/hooks/useShowNavigateBack";

const CarCardPage = () => {
  const { id } = useParams();
  const isMobile = useIsMobile();
  const showPageBack = useShowNavigateBack();
  const { getVehicleCard } = useVehicleCard();
  const vcLabels = vehicleCardUILabels(getLanguage());
  const btnLabels = commonButtonLabels(getLanguage());

  // Get vehicle card with full details
  const { data: vehicleCardDetails, isLoading, error } = getVehicleCard(id);

  if (isLoading) {
    return (
      <LeadboxLayout>
        {showPageBack && (
          <BtnNavigateBack
            label={btnLabels.back}
            to="/admin/leadbox/vehicle-cards"
          />
        )}
        <div className="flex justify-center items-center h-64">
          <div className="text-lg">{vcLabels.loadingDetails}</div>
        </div>
      </LeadboxLayout>
    );
  }

  if (error) {
    return (
      <LeadboxLayout>
        {showPageBack && (
          <BtnNavigateBack
            label={btnLabels.back}
            to="/admin/leadbox/vehicle-cards"
          />
        )}
        <div className="flex justify-center items-center h-64">
          <div className="text-lg text-red-500">
            {vcLabels.errorLoadingDetails}
          </div>
        </div>
      </LeadboxLayout>
    );
  }

  if (!vehicleCardDetails?.data) {
    return (
      <LeadboxLayout>
        {showPageBack && (
          <BtnNavigateBack
            label={btnLabels.back}
            to="/admin/leadbox/vehicle-cards"
          />
        )}
        <div className="flex justify-center items-center h-64">
          <div className="text-lg text-muted-foreground">
            {vcLabels.notFound}
          </div>
        </div>
      </LeadboxLayout>
    );
  }

  const vehicleCard = vehicleCardDetails.data;

  return (
    <LeadboxLayout>
      {showPageBack && (
        <BtnNavigateBack
          label={btnLabels.back}
          to="/admin/leadbox/vehicle-cards"
        />
      )}

      <div className="flex backdrop-blur-md justify-center">
        <CarCardContent vehicleCard={vehicleCard} />
      </div>
    </LeadboxLayout>
  );
};

export default CarCardPage;
